import { BrowserRouter, Route, Routes } from "react-router";
import Login from "./pages/auth/Login";
import ComputeCapacity from "./pages/ComputeCapacity";
import GpuDashboard from "./pages/GpuDashboard";
import GpuManagement from "./pages/GpuManagement";
import Orders from "./pages/Orders";
import BillingDashboard from "./pages/BillingDashboard";
import AuthLayout from "./layout/AuthLayout";
import AuthMiddleware from "./middleware/AuthMiddleware";
import UtilizationDashboard from "./pages/UtilizationDashboard";
import UtilizationDashboardLegacy from "./pages/UtilizationDashboard_Legacy";
import CapacityDashboard from "./pages/CapacityDashboard";
import ProtectedRoute from "./middleware/ProtectedRoute";
import { PERMISSIONS } from "./lib/utils";
import UnAuthorized from "./pages/auth/UnAuthorized";
import UserManagement from "./pages/UserManagement";
import Resources from "./pages/Resources";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route index element={<Login />} />
        <Route path="login" element={<Login />} />

        {/* Protected routes */}
        <Route element={<AuthMiddleware />}>
          <Route element={<AuthLayout />}>
            <Route
              path="utilization-dashboard-legacy"
              element={
                <ProtectedRoute permission={PERMISSIONS.MONITORING_DASHBOARD}>
                  <UtilizationDashboardLegacy />
                </ProtectedRoute>
              }
            />
            <Route
              path="monitoring-dashboard"
              element={
                <ProtectedRoute permission={PERMISSIONS.MONITORING_DASHBOARD}>
                  <UtilizationDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="monitoring-dashboard/resources"
              element={
                <ProtectedRoute permission={PERMISSIONS.MONITORING_DASHBOARD}>
                  <Resources />
                </ProtectedRoute>
              }
            />
            <Route
              path="capacity-dashboard"
              element={
                <ProtectedRoute permission={PERMISSIONS.CAPACITY_DASHBOARD}>
                  <CapacityDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="orders"
              element={
                <ProtectedRoute permission={PERMISSIONS.ORDERS}>
                  <Orders />
                </ProtectedRoute>
              }
            />
            <Route
              path="billing-dashboard"
              element={
                <ProtectedRoute permission={PERMISSIONS.BILLING_DASHBOARD}>
                  <BillingDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="compute-capacity"
              element={
                <ProtectedRoute permission={PERMISSIONS.COMPUTE_CAPACITY}>
                  <ComputeCapacity />
                </ProtectedRoute>
              }
            />
            <Route
              path="gpu-dashboard"
              element={
                <ProtectedRoute permission={PERMISSIONS.GPU_DASHBOARD}>
                  <GpuDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="gpu-management"
              element={
                <ProtectedRoute permission={PERMISSIONS.GPU_MANAGEMENT}>
                  <GpuManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="user-management"
              element={
                <ProtectedRoute permission={PERMISSIONS.USER_MANAGEMENT}>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
            <Route path="/unauthorized" element={<UnAuthorized />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
